import {debounce} from '../../../utils/debounce';
import whenValueChanges from '../../../utils/whenvaluechanges';

class MediaQueryWatcher{
    constructor(mediaQuery, callback){
        if(!mediaQuery || !callback){
            throw new Error('MediaQueryWatcher requires a media query string as well as a callback function');
        }

        this.mediaQuery = mediaQuery;
        this.callback = callback;

        this.callback(this.matchMedia());    
        window.addEventListener('resize', debounce(whenValueChanges(this.matchMedia.bind(this), matches => this.callback(matches), 100)));
    }

    matchMedia(){
        return window.matchMedia(this.mediaQuery).matches;
    }
}

export default MediaQueryWatcher;